import { Typography } from '@mui/material';

interface ITextareaCounter {
  counter: number;
  limit: number;
  hasError: boolean;
}
export const TextareaCounter = ({
  counter,
  limit,
  hasError,
}: ITextareaCounter) => {
  return (
    <Typography
      component='span'
      sx={{
        position: 'absolute',
        bottom: hasError ? '28px' : '5px',
        right: '10px',
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '12px',
      }}
    >{`${counter}/${limit}`}</Typography>
  );
};
